import {
  Heading,
  Box,
  Flex,
} from '@chakra-ui/react';
import { Dispatch, SetStateAction, useState } from 'react';
import { UseMutateFunction } from '@tanstack/react-query';

import { RTyreList } from 'components';
import { SetupSuggestions, Tyres } from 'types';
import {
  SetCarPartMutation,
  MutationSetCarPartsArgs,
  Races,
  SavedSetups,
} from 'api/generated/graphql';
import EngineAndTuning, { EngineAndTuningProps } from './EngineAndTuning';
import {
  useGetRaceById,
} from 'hooks';
import RSavedSetups from '../_components/SavedSetups/SavedSetups';

const SelectTyres = ({
  setSelectedTyres,
  selectedTyres,
  carId,
  mutateCarPart,
  setTuningSelections,
  carStats,
  ...engineAndTuningProps
}: EngineAndTuningProps & {
  setSelectedTyres: Dispatch<SetStateAction<Tyres>>;
  selectedTyres: Tyres;
  carId: string;
  carStats?: Array<{
    metric: string;
    modifier: number;
    description: string;
    bars: number;
  }>;
  mutateCarPart: UseMutateFunction<
    SetCarPartMutation,
    unknown,
    MutationSetCarPartsArgs,
    unknown
  >;
}) => {
  const [selectedSavedSetup, setSelectedSavedSetup] =
    useState<SavedSetups | null>(null);


  const { data: raceByIdData } = useGetRaceById({
    raceId: engineAndTuningProps.tuningSelections.raceId,
  });
  const race = raceByIdData?.getRaceById?.race as Races;

  const rawSuggestions = race?.setupSuggestions;
  const tyreSuggestions = raceByIdData?.getRaceById?.tyreSuggestions;
  const setupSuggestions: SetupSuggestions =
    rawSuggestions && JSON.parse(rawSuggestions);

  return (
    <Box height="fit-content" pb={{ base: '4', md: '20' }} pr={{ base: '2', md: '4'}}>
      <Flex justify="space-between" align="center" mb="6">
        <Heading
          as="h1"
          fontSize="1.125rem"
          fontWeight={400}
          textTransform="uppercase"
          color="white.95"
        >
          Car Setup
        </Heading>
        <RSavedSetups
          carId={carId}
          tuningSelections={engineAndTuningProps.tuningSelections}
          selectedSavedSetup={selectedSavedSetup}
          setSelectedSavedSetup={setSelectedSavedSetup}
          selectedTyres={selectedTyres}
          setTuningSelections={setTuningSelections}
          setSelectedTyres={setSelectedTyres}
        />
      </Flex>

      <RTyreList
        raceId={engineAndTuningProps.tuningSelections.raceId}
        setupSuggestions={setupSuggestions}
        tyreSuggestions={tyreSuggestions}
        raceDifficulty={race.difficulty}
        setSelectedTyres={setSelectedTyres}
        selectedTyres={selectedTyres as Tyres}
        carId={engineAndTuningProps.tuningSelections.carId}
        mutateCarPart={mutateCarPart}
      />

      <EngineAndTuning
        selectedTyres={selectedTyres}
        carId={carId}
        setTuningSelections={setTuningSelections}
        carStats={carStats}
        {...engineAndTuningProps}
      />
    </Box>
  );
};

export default SelectTyres;
